import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import QuoteModal from './QuoteModal';

export default function FloatingQuoteButton() {
  const [hovered, setHovered] = useState(false);
  const [quoteOpen, setQuoteOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <button
        onClick={() => setQuoteOpen(true)}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        className="fixed bottom-8 right-8 z-30 flex items-center gap-3 bg-gradient-to-br from-brand-green to-brand-blue text-white font-semibold rounded-full shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer whitespace-nowrap overflow-hidden"
        style={{ padding: hovered ? '14px 24px 14px 20px' : '14px' }}
      >
        <div className="w-7 h-7 flex items-center justify-center flex-shrink-0">
          <i className="ri-calculator-line text-xl" />
        </div>
        {hovered && <span className="text-sm">{t('fb_text')}</span>}
      </button>
      <QuoteModal isOpen={quoteOpen} onClose={() => setQuoteOpen(false)} />
    </>
  );
}
